const personalInfo = {
    name: "Maxwell McVay",
    title: "Software Engineer",
    summary: "",
    skills: ["React", "Node.js", "JavaScript", "C#", ".NET", "Python", "C++", "Docker", "Bash", "MongoDB", "SQL", "Vim"],
    experience: [
      {
        company: "Colibri Group",
        role: "Software Engineer",
        period: "February 2025 - Present",
        responsibilities: [
          "Spearheaded a large-scale data migration of 10+ years of historical NetCE data into Colibri's Common Platform with zero data loss",
          "Developed crosswalk field mappings and complex PostgreSQL queries to support the migration pipeline via the internal Data Migration Engine",
          "Engineered an automated eligibility script that runs every 30 minutes, executing a 40+ field SQL query to determine student submission readiness",
          "Migrated the evaluation process off NetSuite CRM to a local environment, reducing runtime from 5–6 minutes to under 10 seconds (~97% improvement)",
          "Developed RESTful API endpoints for cart creation and removal as part of a new e-commerce platform build",
          "Built the front-end shipping page following internal design system and component guidelines",
          "Prototyped an AI-powered internal PIM system; evaluated and presented findings before the company opted for a third-party solution",
        ] 
      },
      {
        company: "Cyber Skyline",
        role: "Software Engineer",
        period: "June 2023 - September 2024",
        responsibilities: [
            "Led full‐stack development for web applications, handling both front‐end (React) and back‐end (Node.js) code, overseeing the full lifecycle of projects from concept to deployment",
            "Redesigned and improved the main platform dashboard, enhancing user experience and overall design",
            "Ensured the platform's ADA compliance, enhancing accessibility for users with disabilities",
            "Headed customer support operations, acting as the primary point of contact for the user community and managing escalations",
            "Developed and maintained the company's Service Level Agreement (SLA), defining support standards and response times",
            "Improved the ticketing system and made platform enhancements to reduce the number of incoming support requests, driving efficiency in support operations",
            "Developed cybersecurity training content for military organizations and the NSA, contributing to national security training efforts",
            "Functioned as a cybersecurity expert, designing and developing realistic, hands-on cybersecurity challenges for the National Cyber League (NCL), annually engaging 10,000–12,000 players to develop and sharpen their cybersecurity skills",
            "Collaborated with cross-functional teams in a small startup environment, managing multiple business and technical responsibilities and adapting quickly to changing needs",
            "Designed and implemented solutions using a customer-centric and user-centric approach, focusing on enhancing user experience and addressing customer needs through platform improvements and streamlined support processes",
          ]
      },
      {
        company: "Solidigm",
        role: "Systems Production Engineer",
        period: "May 2022 - December 2022",
        responsibilities: [
            "Developed Python scripts to automate the ingestion and parsing of data from multiple file types, reducing manual input and increasing data processing efficiency",
            "Parsed and transformed complex datasets into XML format, optimizing data structure for more streamlined and efficient input into a database system",
            "Improved data management processes by automating routine tasks, significantly reducing human error and manual intervention, which contributed to increased organizational efficiency and operational productivity",
            "Gained hands‑on experience in working with large data sets, learning best practices in data transformation, scripting, and system integrations",
          ]
      },
    ],
    education: {
      degree: "B.S. in Computer Science",
      institution: "California State University - Chico",
      year: "2023",
      gpa: "3.58 GPA"
    },
    contact: {
      email: "maxmcvay@gmail.com",
      github: "mhmcvay",
      linkedin: "maxwell-mcvay"
    }
  };
  
  export default personalInfo;
